import * as React from "react";
import { DayPicker, MonthCaptionProps, useNavigation } from "react-day-picker";
import moment from "moment";
import "react-day-picker/dist/style.css";
import "./custom-calendar.css";

import {
    IoIosArrowRoundUp,
    IoIosArrowRoundDown,
    IoIosArrowDown,
} from "react-icons/io";

const ArrowRoundUp = IoIosArrowRoundUp as React.ComponentType;
const ArrowRoundDown = IoIosArrowRoundDown as React.ComponentType;
const ArrowDown = IoIosArrowDown as React.ComponentType;

/* ---------- Custom Caption ---------- */
function CustomMonthCaption({ calendarMonth }: MonthCaptionProps) {
    const { goToMonth, nextMonth, previousMonth } = useNavigation();
    const [open, setOpen] = React.useState(false);

    const BASE_YEAR = moment().year(); // 🔒 fixed base year (2025)
    const selectedYear = moment(calendarMonth.date).year();
    const monthIndex = moment(calendarMonth.date).month();

    const years = Array.from({ length: 6 }, (_, i) => BASE_YEAR + i);

    return (
        <div className="custom-caption">
            <div className="month-wrapper">
                <button
                    type="button"
                    className="month-label"
                    onClick={() => setOpen(!open)}
                >
                    {moment(calendarMonth.date).format("MMMM, YYYY")}
                    <ArrowDown />
                </button>

                {open && (
                    <div className="year-dropdown">
                        {years.map((year) => (
                            <button
                                type="button"
                                key={year}
                                className={`year-option ${year === selectedYear ? "active" : ""
                                    }`}
                                onClick={() => {
                                    goToMonth(new Date(year, monthIndex));
                                    setOpen(false);
                                }}
                            >
                                {year}
                            </button>
                        ))}
                    </div>
                )}
            </div>

            <div className="nav-buttons">
                <button
                    type="button"
                    disabled={!previousMonth}
                    onClick={() => previousMonth && goToMonth(previousMonth)}
                >
                    <ArrowRoundUp />{""}
                </button>

                <button
                    type="button"
                    disabled={!nextMonth}
                    onClick={() => nextMonth && goToMonth(nextMonth)}
                >
                    <ArrowRoundDown />{""}
                </button>
            </div>
        </div>
    );
}

/* ---------- Date Picker ---------- */
interface CustomDatePickerProps {
    value: string;
    onChange: (date: string) => void;
    disabled?: boolean;
}

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({
    value,
    onChange,
    disabled,
}) => {
    const selectedDate = value ? moment(value).toDate() : undefined;

    return (
        <DayPicker
            mode="single"
            selected={selectedDate}
            disabled={disabled ? undefined : { before: new Date() }}
            onSelect={(date) => {
                if (!date) return;
                onChange(moment(date).format("YYYY-MM-DD"));
            }}
            fromYear={2020}
            toYear={2035}
            captionLayout="dropdown"
            components={{
                MonthCaption: CustomMonthCaption,
            }}
            className="custom-calendar"
        />
    );
};

export default CustomDatePicker;
